import React, { useCallback, useEffect, useRef, useState } from "react";
import Banner from "src/components/molecules/banner/Banner";
import MobileAppList from "../mobile-app-list/mobile-app-list";
import MobileAppAddNew from "../mobile-app-add-new/mobile-app-add-new";
import { IMobileAppModel } from "src/types/models/apiModels";
import { MobileAppViewModel } from "./mobile-app-viewmodel";
import { useAuth } from "../auth/auth-context";

interface MobileAppProps {
	openInEditMode?: boolean;
}

const MobileApp: React.FC<MobileAppProps> = ({ openInEditMode }) => {
	const { user } = useAuth(); // Extract user from useAuth hook
	const [editMode, setEditMode] = useState<boolean>(openInEditMode ?? false);
	const [title, setTitle] = useState("Mobile Apps");
	const [mobileApp, setMobileApp] = useState<IMobileAppModel | undefined>(
		undefined
	);
	const viewModel = useRef<MobileAppViewModel | null>(null);
	useEffect(() => {
		if (user && user.accessToken) {
			viewModel.current = new MobileAppViewModel(user.accessToken);
		}
	}, []);

	useEffect(() => {
		if (editMode) {
			setTitle("Add / Edit Mobile App");
		} else {
			setTitle("Mobile Apps");
			setMobileApp(undefined);
		}
	}, [editMode]);

	const handleSave = useCallback((mobileApp: IMobileAppModel) => {
		console.log("handleSave!", mobileApp);
		toggleEditMode();
	}, []);

	const handleOnCancel = useCallback(() => {
		toggleEditMode();
	}, []);

	const handleOnAdd = useCallback(() => {
		toggleEditMode();
	}, []);

	const handleSelectedApp = async (selectedApp: IMobileAppModel) => {
		setMobileApp(selectedApp);
		toggleEditMode();
	};

	const toggleEditMode = () => {
		setEditMode((prevValue) => !prevValue);
	};

	return (
		<Banner label={title}>
			<div className="drop-shadow-2xl">
				{editMode === false ? (
					<div className="bg-white p-6 w-full overflow-auto rounded-lg drop-shadow-2xl">
						<MobileAppList
							onAddNewClick={() => setEditMode(true)}
							onEditClicked={(app) => {
								setMobileApp(app);
								setEditMode(true);
							}}
							onDeleteClicked={(app) => {
								console.log(`not in use`, app);
							}}
						></MobileAppList>
					</div>
				) : (
					<MobileAppAddNew
						mobileApp={mobileApp}
						onSave={handleSave}
						onCancel={handleOnCancel}
					></MobileAppAddNew>
				)}
			</div>
		</Banner>
	);
};

export default MobileApp;
